import React, { lazy, Suspense } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const SocialProof = lazy(() => import('./components/sections/SocialProof').then(mod => ({
  default: mod.SocialProof
})));
const Differentiators = lazy(() => import('./components/sections/Differentiators').then(mod => ({
  default: mod.Differentiators
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const Method = lazy(() => import('./components/sections/Method').then(mod => ({
  default: mod.Method
})));
const PracticeCards = lazy(() => import('./components/sections/PracticeCards').then(mod => ({
  default: mod.PracticeCards
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const AboutAuthor = lazy(() => import('./components/sections/AboutAuthor').then(mod => ({
  default: mod.AboutAuthor
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="d45ua5nl4fnm">
      <div className="w-full min-h-full bg-white font-body text-gris-texto" data-id="element-1" data-mp="85uihpdqbv2r">
        <main data-id="element-2" data-mp="83i6rtykegy5">
          <Hero data-id="element-3" data-mp="3glea6jyr55fp" />
          <Suspense fallback={null} data-id="element-4" data-mp="3gkv2dw2tfxfe">
            <SocialProof data-id="element-5" data-mp="3glwbhv09u9uh" />
            <Differentiators data-id="element-6" data-mp="3gj1ru5p30t24" />
            <Transformation data-id="element-7" data-mp="3bmthd5ltxo1a" />
            <Method data-id="element-8" data-mp="3bnmf5h2t937a" />
            <PracticeCards data-id="element-9" data-mp="3bo4j6zvpslpr" />
            <ForYou data-id="element-10" data-mp="3qb7m5m2t3mkh" />
            <WhatYouGet data-id="element-11" data-mp="3qbfx38fdcht1" />
            <InstantAccess data-id="element-12" data-mp="3qbzcoihjqu3w" />
            <Testimonials data-id="element-13" data-mp="3qdag2h72xzuh" />
            <AboutAuthor data-id="element-14" data-mp="3lkr4tqvv7gsu" />
            <Pricing data-id="element-15" data-mp="3ljg1fs6c0b29" />
            <Guarantee data-id="element-16" data-mp="3liwgs3par8kj" />
            <FAQ data-id="element-17" data-mp="3limq0dwfgxds" />
            <FinalCTA data-id="element-18" data-mp="2xun4pthvxz6l" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-19" data-mp="2xt29e1nqyc7o">
          <Footer data-id="element-20" data-mp="2sw20zk3fcxde" />
        </Suspense>
        <StickyCTA data-id="element-21" data-mp="2sv0pjeihy8v5" />
      </div>
    </LazyMotion>;
}